module.exports = __webpack_public_path__ + "img/Home-Calculator.df9a140e.jpg";